import request from "/utils/request";
import globals from "/utils/globals";
import getLocale from "/utils/locale";

export default () => {
  let requestParams = {
    locale: getLocale()
  };

  if (globals.couponCode) {
    requestParams.coupon_code = globals.couponCode; // eslint-disable-line camelcase
  }

  return request
    .get("/api/plans", {
      params: requestParams
    })
    .then(config => {
      if (config) {
        return config;
      } else {
        throw new Error("No plans found.");
      }
    });
};
